import bbtNative from '@bbtfe/native';
import queryString from 'utils/query-string';
import { UAParser } from 'utils/index';
const userAgent = UAParser();
const { CanEatApp } = userAgent;

if (!bbtNative.isApp() && !CanEatApp) {
  bbtNative.userinfo = {};
  bbtNative.ready = function (callback) {
    callback && callback(bbtNative);
  };
  bbtNative.encryptApi = function (query = {}, callback) {
    query.skip = 1;
    callback &&
      callback(
        queryString
          .stringifyUrl({
            url: '',
            query
          })
          .slice(1)
      );
  };
}
